<script setup>
import HeroSection from '@/Components/Website/home/HeroSection.vue'
import AboutBrief from '@/Components/Website/home/AboutBrief.vue'
import GlobalReach from '@/Components/Website/home/GlobalReach.vue'
import BrandAffiliate from '@/Components/Website/home/BrandAffiliate.vue'
import SolutionsPreview from '@/Components/Website/home/SolutionsPreview.vue'
import EnvironmentalCommitment from '@/Components/Website/home/EnvironmentalCommitment.vue'
import SocialResponsibility from '@/Components/Website/home/SocialResponsibility.vue'
import CertificationsPreview from '@/Components/Website/home/CertificationsPreview.vue'
import TestimonialsPreview from '@/Components/Website/home/TestimonialsPreview.vue'
import HowToUsePreview from '@/Components/Website/home/HowToUsePreview.vue'
import ContactPreview from '@/Components/Website/home/ContactPreview.vue'
import OurValues from '@/Components/Website/home/OurValues.vue'
import FacilitiesInsights from '@/Components/Website/home/FacilitiesInsights.vue'
import WebsiteLayout from '@/Layouts/WebsiteLayout.vue'

import { Head } from '@inertiajs/vue3'
import { usePage } from '@inertiajs/vue3'
import { computed, defineAsyncComponent } from 'vue'
const BlogSection = defineAsyncComponent(() => import("@/Components/BlogSection.vue"));
const ContactForm = defineAsyncComponent(() => import("@/Components/ContactForm.vue"));
const Schema = defineAsyncComponent(() => import("@/Components/Schema.vue"));

defineOptions({ layout: WebsiteLayout })
defineProps(['brands'])
const page = usePage()
const settings = computed(() => page.props.setting || {})
const locale = computed(() => page.props.locale || 'en')
const isRtl = computed(() => locale.value === 'ar')
</script>

<template>

    <Head>
        <title head-key="title">
            {{ settings.site_seo_title[locale] || settings.site_title[locale] }} | {{ __t("home") }}
        </title>
        <meta head-key="description" name="description" :content="settings.site_descr[locale]" />
        <meta head-key="keywords" name="keywords" :content="settings.site_keywords[locale]" />
        <meta property="og:type" content="website" head-key="og:type" />
        <meta property="og:title" head-key="og:title" :content="settings.site_seo_title[locale]" />
        <meta property="og:description" head-key="og:description" :content="settings.site_descr[locale]" />
        <meta property="og:image" head-key="og:image" :content="$page.props.setting.home_logolight" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" :content="settings.site_seo_title[locale]" />
        <meta name="twitter:description" :content="settings.site_descr[locale]" />
        <meta name="twitter:image" :content="$page.props.setting.home_logolight" />
    </Head>
    <Schema type="web" />
    <div class="home-view overflow-hidden">

        <HeroSection />
        <AboutBrief />
        <GlobalReach />
        <OurValues />
        <!-- <BrandAffiliate :brands="brands" /> -->

        <SolutionsPreview />
        <FacilitiesInsights />

        <EnvironmentalCommitment />
        <SocialResponsibility />
        <CertificationsPreview />
        <BlogSection />
        <ContactForm />
        <!-- <HowToUsePreview /> -->
        <!-- <TestimonialsPreview /> -->
        <!-- <ContactPreview /> -->
        <div class="mb-16 max-w-7xl mx-auto transform hover:-translate-y-2 transition-all duration-700"
            :dir="isRtl ? 'rtl' : 'ltr'">
            <div
                class=" backdrop-blur-xl rounded-[2rem] p-6 md:p-10  border border-gray-100 relative overflow-hidden group">
                <!-- Background Decor -->
                <div
                    class="absolute top-0 right-0 w-64 h-64 bg-secondary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 group-hover:scale-150 transition-transform duration-1000">
                </div>

                <div class="relative z-10 max-w-4xl mx-auto">
                    <!-- Points of Sale Section Only -->
                    <div class="space-y-6 text-center">
                        <div
                            class="inline-flex items-center gap-3 px-5 py-2 bg-secondary/10 rounded-full text-primary font-bold text-xs uppercase tracking-wider mb-1">
                            <v-icon size="16" class="text-secondary ">mdi-store</v-icon>
                            {{ __t('footer_pos_title') }}
                        </div>
                        <h2 class="text-2xl md:text-3xl font-black text-primary leading-tight">
                            {{ __t('authorized_sales_centers') }}
                        </h2>
                        <p class="text-gray-600  leading-relaxed max-w-3xl mx-auto">
                            {{ __t('footer_pos_description') }}
                        </p>

                        <!-- Tags for quick scan -->
                        <div class="flex flex-wrap gap-3 pt-6 justify-center">
                            <span
                                v-for="city in (isRtl ? ['سلمية', 'السويداء', 'بانياس', 'حلب', 'حماة', 'حمص', 'درعا', 'دمشق', 'طرطوس', 'صافيتا', 'عدرا', 'لبنان'] : ['Salamiyah', 'As-Suwayda', 'Baniyas', 'Aleppo', 'Hama', 'Homs', 'Daraa', 'Damascus', 'Tartus', 'Safita', 'Adra', 'Lebanon'])"
                                :key="city"
                                class="px-3.5 py-1.5 bg-slate-50 rounded-xl text-gray-500 font-bold text-xs hover:bg-secondary hover:text-primary hover:-translate-y-1 transition-all duration-300 border border-gray-100 shadow-sm hover:shadow-secondary/20">
                                {{ city }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
